<script lang="ts">
  import { writable, type Writable } from "svelte/store";
  import { popover, type PopoverParams, type PositionOptions } from "../../actions/popover";

  const DEFAULT_OPTIONS: PositionOptions = {
    offset: 3,
    placement: "right",
    strategy: "absolute",
  };

  const arrowElement = writable<HTMLElement | null>(null);
  export let open = false;
  export let anchorElement: Writable<HTMLElement | null>;
  export let options: PositionOptions = DEFAULT_OPTIONS;

  let popoverParams: PopoverParams;
  $: popoverParams = {
    open,
    anchorElement,
    options: {
      arrow: { element: arrowElement },
      ...options,
    },
  };
</script>

{#if open}
  <div class="tooltip" use:popover={popoverParams}>
    <slot />
    <div class="arrow" bind:this={$arrowElement} />
  </div>
{/if}

<style>
  .tooltip {
    background-color: var(--rk-neutral-4);
    border-radius: var(--rk-rounding-s);
    padding: 8px 16px;
    z-index: 10;
  }

  .arrow {
    position: absolute;
    width: 12px;
    height: 12px;
    background-color: var(--rk-neutral-4);
    z-index: 9;
  }
</style>
